export default __webpack_public_path__ + "static/media/n3.f60b44e3.jpg";